import React, { useContext } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import SecuredByLogo from '../assets/images/secured-by-dataswift.svg';
import { config } from '../configs/config';
import COLOURS from '../constants/colour';
import TwitterIcon from '@material-ui/icons/Twitter';
import { AuthContext } from '../components/Context/AuthContext'
import { UserRoles } from '../constants/role';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '120px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '72px',
    paddingBottom: '30px',
  },
  poweredBy: {
    opacity: '0.5',
    color: COLOURS.MediumGrey,
    fontSize: '12px',
  },
  securedByLogo: {
    height: '96px',
    width: '96px',

    [theme.breakpoints.down('sm')]: {
      height: '72px',
      width: '72px',
    },
  },
  termsLink: {
    marginTop: '32px',
    marginBottom: '32px',
    fontSize: '11px',
    color: COLOURS.Dark,
    lineHeight: '20px',
  },
  copyRights: {
    fontSize: '11px',
    color: COLOURS.Dark,
    lineHeight: '20px',
    maxWidth: '552px',
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
}));

export const Footer: React.FC = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  return (
    <footer className={classes.root}>
      <a
        href={config.dataswiftLink}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.imageWrapper}
      >
        <img src={SecuredByLogo} alt="Secured By Dataswift" className={classes.securedByLogo} />
      </a>

      <p style={{ textAlign: 'center' }}>
        SejutaKG Application <br /><a
          href="https://www.datapassport.com/sejutakg/application-tos"
          target="_blank"
          rel="noopener noreferrer">
          Terms of Service
        </a> and <a
          href="https://www.datapassport.com/sejutakg/privacy-policy"
          target="_blank"
          rel="noopener noreferrer">
          Privacy Policy
        </a>
      </p>
      <Typography align="center" className={classes.copyRights}>
        &#169; {new Date().getFullYear()}, DATASWIFT INC All rights reserved
      </Typography>

      <Typography align="center" className={classes.copyRights}>
        <a
          href="https://twitter.com/sejutaKG"
          target="_blank"
          rel="noopener noreferrer"
        ><TwitterIcon fontSize="large" /></a>
      </Typography>
      {user.isAuthenticated && user.role === UserRoles.MERCHANT &&
        <Typography align="center" className={classes.copyRights}>
          This Merchant Data Terminal Application is in <strong>BETA TESTING Mode</strong>.
        </Typography>
      }
    </footer>
  );
};
